module.exports = __webpack_public_path__ + "static/img/guazi.694611ed.png";